export default {
  COLLECTION_API: '/collections/api',
  RELEWISE_STAGE_API: 'https://stage01-api.relewise.com/7962b125-6725-4248-bc22-40a9a7716730/v1/',
  RELEWISE_PROD_API: 'https://api.relewise.com/5c0f81e8-824e-4e42-9c3d-a294e0e4add2/v1/',
  RELEWISE_STAGE_API_KEY: '7962b125-6725-4248-bc22-40a9a7716730',
  RELEWISE_PROD_API_KEY: '5c0f81e8-824e-4e42-9c3d-a294e0e4add2',
};
